import { Link } from 'react-router-dom';

export default function CollectionsBanner() {
  return (
    <section className="w-full relative overflow-hidden h-[560px] md:h-[640px]">
      {/* Background */}
      <img
        src="https://public.readdy.ai/ai/img_res/77f8c5d29dbd5ef22d5eb290b5cbd5b7.jpg"
        alt="Premium sofa bed collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between px-8 md:px-20 py-14">
        {/* Top */}
        <div className="max-w-xl">
          <p className="text-white/60 text-xs tracking-[0.3em] uppercase mb-3">New Arrivals 2025</p>
          <h2 className="text-5xl md:text-7xl font-bold text-white leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Sleep Better.<br />
            <em className="not-italic text-[#d4b896]">Live Smarter.</em>
          </h2>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <p className="text-white/75 text-lg max-w-sm leading-relaxed">
            Discover our newest sofa beds — engineered for nightly comfort and daily style, starting at $159.
          </p>
          <Link
            to="/products"
            className="whitespace-nowrap flex items-center gap-3 bg-white text-[#2c2420] text-sm font-semibold tracking-wide px-6 py-4 rounded-full hover:bg-[#f5ede4] transition-colors duration-200 cursor-pointer self-start sm:self-auto"
          >
            Shop New Arrivals
            <span className="w-7 h-7 flex items-center justify-center bg-[#2c2420] text-white rounded-full">
              <i className="ri-arrow-right-line text-sm" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
